export var NAME = 'user';
export var ADDRESS_DELETED = "".concat(NAME, "/ADDRESS_DELETED");
export var ADDRESS_UPDATED = "".concat(NAME, "/ADDRESS_UPDATED");
export var FAPIAO_CANCELLED = "".concat(NAME, "/FAPIAO_CANCELLED");
export var USER_ACCEPTED_WFOE_TOS = "".concat(NAME, "/USER_ACCEPTED_WFOE_TOS");
export var USER_ACCEPTED_WFOE_TOS_REQUESTED = "".concat(NAME, "/USER_ACCEPTED_WFOE_TOS_REQUESTED");
export var USER_INVALIDATED = "".concat(NAME, "/USER_INVALIDATED");
export var USER_INVOICING_DATA_LOADED = "".concat(NAME, "/USER_INVOICING_DATA_LOADED");
export var USER_LOADED = "".concat(NAME, "/USER_LOADED");
export var USER_LOADING_FINISHED = "".concat(NAME, "/USER_LOADING_FINISHED");
export var USER_ORDER_COUNT_LOADED = "".concat(NAME, "/USER_ORDER_COUNT_LOADED");
export var USER_PREFERRED_GROUP_ADDED = "".concat(NAME, "/USER_PREFERRED_GROUP_ADDED");
export var USER_PREFERRED_GROUP_REMOVED = "".concat(NAME, "/USER_PREFERRED_GROUP_REMOVED");
export var USER_SKIPPED_WFOE_NOTICE = "".concat(NAME, "/USER_SKIPPED_WFOE_NOTICE");
export var USER_UPDATED = "".concat(NAME, "/USER_UPDATED");
export var USER_REWARD_POINTS_UPDATED = "".concat(NAME, "/USER_REWARD_POINTS_UPDATED");
export var USER_WFOE_OPT_IN = "".concat(NAME, "/USER_WFOE_OPT_IN");